<template>
    <div class="cc-invoice-address">
        <div class="cc-invoice-address__header">
            <div class="cc-invoice-address__title">{{ translations['Invoice address'] }}</div>
        </div>
        <div class="cc-invoice-address__main">
            <div class="cc-form-input">
                <label for="invoiceAddress.firstname" class="cc-label cc-label--text">{{ translations['Firstname'] }}*</label>
                <input id="invoiceAddress.firstname" type="text" name="invoiceAddress.firstname" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.invoiceAddress.firstname}" :value="user.invoiceAddress.firstname" @change="updateFirstname">
                <div class="cc-alert cc-alert--error" v-if="user.errors.invoiceAddress.firstname">{{ user.errors.invoiceAddress.firstname }}</div>
            </div>
            <div class="cc-form-input">
                <label for="invoiceAddress.lastname" class="cc-label cc-label--text">{{ translations['Lastname'] }}*</label>
                <input id="invoiceAddress.lastname" type="text" name="invoiceAddress.lastname" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.invoiceAddress.lastname}" :value="user.invoiceAddress.lastname" @change="updateLastname">
                <div class="cc-alert cc-alert--error" v-if="user.errors.invoiceAddress.lastname">{{ user.errors.invoiceAddress.lastname }}</div>
            </div>
            <div class="cc-form-input">
                <label for="invoiceAddress.phone" class="cc-label cc-label--text">{{ translations['Phone'] }}</label>
                <input id="invoiceAddress.phone" type="text" name="invoiceAddress.phone" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.invoiceAddress.phone}" :value="user.invoiceAddress.phone" @change="updatePhone">
                <div class="cc-alert cc-alert--error" v-if="user.errors.invoiceAddress.phone">{{ user.errors.invoiceAddress.phone }}</div>
            </div>
            <div class="cc-form-input">
                <label for="invoiceAddress.addressLine1" class="cc-label cc-label--text">{{ translations['Address'] }}*</label>
                <input id="invoiceAddress.addressLine1" type="text" name="invoiceAddress.addressLine1" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.invoiceAddress.addressLine1}" :value="user.invoiceAddress.addressLine1" @change="updateAddressLine1">
                <div class="cc-alert cc-alert--error" v-if="user.errors.invoiceAddress.addressLine1">{{ user.errors.invoiceAddress.addressLine1 }}</div>
            </div>
            <div class="cc-form-input">
                <label for="invoiceAddress.country" class="cc-label cc-label--text">{{ translations['Country'] }}*</label>
                <select id="invoiceAddress.country" name="invoiceAddress.country" class="cc-input cc-input--select" :value="user.invoiceAddress.country" @change="updateCountry">
                    <option value="" disabled="disabled">{{ translations['Select country'] }}</option>
                    <option v-for="country in countries" v-bind:key="country.id" :value="country.id">{{ country.name }}</option>
                </select>
                <div class="cc-alert cc-alert--error" v-if="user.errors.invoiceAddress.country">{{ user.errors.invoiceAddress.country }}</div>
            </div>
            <div class="cc-form-input">
                <label for="invoiceAddress.postalCode" class="cc-label cc-label--text">{{ translations['Postal code'] }}*</label>
                <input id="invoiceAddress.postalCode" type="text" name="invoiceAddress.postalCode" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.invoiceAddress.postalCode}" :value="user.invoiceAddress.postalCode" @change="updatePostalCode">
                <div class="cc-alert cc-alert--error" v-if="user.errors.invoiceAddress.postalCode">{{ user.errors.invoiceAddress.postalCode }}</div>
            </div>
            <div class="cc-form-input">
                <label for="invoiceAddress.city" class="cc-label cc-label--text">{{ translations['City'] }}*</label>
                <input id="invoiceAddress.city" type="text" name="invoiceAddress.city" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.invoiceAddress.city}" :value="user.invoiceAddress.city" @change="updateCity">
                <div class="cc-alert cc-alert--error" v-if="user.errors.invoiceAddress.city">{{ user.errors.invoiceAddress.city }}</div>
            </div>
            <div class="cc-form-input">
                <label for="invoiceAddress.company" class="cc-label cc-label--text">{{ translations['Company'] }}</label>
                <input id="invoiceAddress.company" type="text" name="invoiceAddress.company" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.invoiceAddress.company}" :value="user.invoiceAddress.company" @change="updateCompany">
                <div class="cc-alert cc-alert--error" v-if="user.errors.invoiceAddress.company">{{ user.errors.invoiceAddress.company }}</div>
            </div>
            <div class="cc-form-input">
                <label for="invoiceAddress.identificationNumber" class="cc-label cc-label--text">{{ translations['Identification number'] }}</label>
                <input id="invoiceAddress.identificationNumber" type="text" name="invoiceAddress.identificationNumber" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.invoiceAddress.identificationNumber}" :value="user.invoiceAddress.identificationNumber" @change="updateIdentificationNumber">
                <div class="cc-alert cc-alert--error" v-if="user.errors.invoiceAddress.identificationNumber">{{ user.errors.invoiceAddress.identificationNumber }}</div>
            </div>
            <div class="cc-form-input">
                <label for="invoiceAddress.taxIdentificationNumber" class="cc-label cc-label--text">{{ translations['Tax identification number'] }}</label>
                <input id="invoiceAddress.taxIdentificationNumber" type="text" name="invoiceAddress.taxIdentificationNumber" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.invoiceAddress.taxIdentificationNumber}" :value="user.invoiceAddress.taxIdentificationNumber" @change="updateTaxIdentificationNumber">
                <div class="cc-alert cc-alert--error" v-if="user.errors.invoiceAddress.taxIdentificationNumber">{{ user.errors.invoiceAddress.taxIdentificationNumber }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                user: state => state.user,
                countries: state => state.config.countries,
                isUserLoggedIn: state => state.isLoggedIn,
            }),
        },
        methods: {
            updateFirstname: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_FIRSTNAME', event.target.value);
            },
            updateLastname: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_LASTNAME', event.target.value);
            },
            updatePhone: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_PHONE', event.target.value);
            },
            updateAddressLine1: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_ADDRESS_LINE_1', event.target.value);
            },
            updateCountry: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_COUNTRY', event.target.value);
            },
            updatePostalCode: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_POSTAL_CODE', event.target.value);
            },
            updateCity: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_CITY', event.target.value);
            },
            updateCompany: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_COMPANY', event.target.value);
            },
            updateIdentificationNumber: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_IDENTIFICATION_NUMBER', event.target.value);
            },
            updateTaxIdentificationNumber: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_TAX_IDENTIFICATION_NUMBER', event.target.value);
            },
        },
        name: 'InvoiceAddress',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/main";

    #app {
        .cc-invoice-address {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-invoice-address__header {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-invoice-address__title {
            font-family: "Oswald", sans-serif;
            font-size: 25px;
            line-height: 1;
            display: inline-block;
            text-transform: uppercase;
        }

        .cc-invoice-address__main {
            display: block;
            width: 100%;
            max-width: 100%;
            margin-top: 2.5rem;
        }

        .cc-input {
            &.cc-input--text {
                width: 100%;
            }

            &.cc-input--select {
                width: 100%;
            }
        }
    }
</style>
